module.exports = __webpack_public_path__ + "static/img/h_40@2x.8ca71722.png";